import { Service } from '@wix/ambassador-bookings-services-v2-service/types';
import type { CalendarSelections } from '@wix/bookings-catalog-calendar-viewer-utils';
import { isStaffMemberConnectedToService } from '@wix/bookings-calendar-catalog-viewer-mapper';
import { SelectedBookingPreference } from '../bookingPreferences/bookingPreferences';
import { Preference } from '../../types/types';
import { DO_NOT_CARE_STAFF } from '../../constants/constants';

export const initializeSelectedBookingPreferences = ({
  calendarSelections,
  servicesInView,
}: {
  calendarSelections?: CalendarSelections;
  servicesInView: Service[];
}): SelectedBookingPreference[] => {
  const selectedPreferences: SelectedBookingPreference[] = [];

  if (!calendarSelections) {
    return selectedPreferences;
  }

  if (calendarSelections.location) {
    selectedPreferences.push({
      key: Preference.LOCATION,
      value: calendarSelections.location,
    });
  }

  if (calendarSelections.services?.length > 0 && servicesInView.length > 0) {
    const firstService = calendarSelections.services[0];
    const currentService = servicesInView[0];

    if (firstService.resources?.length > 0) {
      const staffMemberId = firstService.resources[0];

      const isStaffValid =
        staffMemberId === DO_NOT_CARE_STAFF ||
        isStaffMemberConnectedToService(currentService, staffMemberId);

      if (isStaffValid) {
        selectedPreferences.push({
          key: Preference.STAFF_MEMBER,
          value: staffMemberId,
        });
      }
    }

    if (firstService.variants && firstService.variants.length > 0) {
      const durationVariant = firstService.variants.find(
        (variant) => variant.choices?.[0]?.duration,
      );

      if (durationVariant?.choices?.[0]?.id) {
        selectedPreferences.push({
          key: Preference.DURATION,
          value: durationVariant.choices[0].id,
        });
      }

      const customVariant = firstService.variants.find(
        (variant) => variant.choices?.[0]?.custom,
      );

      if (customVariant?.choices?.[0]?.custom) {
        selectedPreferences.push({
          key: Preference.CUSTOM,
          value: customVariant.choices[0].custom,
        });
      }
    }
  }

  return selectedPreferences;
};
